import React from "react";

const NavigationButtons = ({ onPrevious, onNext, disablePrevious, disableNext }) => {
  return (
    <div className="d-flex justify-content-between mb-4">
      <button className="btn btn-primary" style={{ width: "250px" }} onClick={onPrevious} disabled={disablePrevious}>
        Previous
      </button>
      <button className="btn btn-primary" style={{ width: "250px" }} onClick={onNext} disabled={disableNext}>
        Next
      </button>
    </div>
  );
};

export default NavigationButtons;
